<template>
  <div class="bc-card" :style="'border-top: 3px solid ' + cardColor">
    <!-- Header -->
    <div class="bc-header d-flex justify-content-between align-items-center">
      <span class="bc-type-label" :style="'color:' + cardColor">{{ cardTitle }}</span>
      <span class="bc-id text-muted">#{{ BankConciliationItem.Id }}</span>
    </div>

    <!-- Extrato bancário -->
    <template v-if="BankConciliationItem.TypeConciliation == 1">
      <div class="bc-bank-row border-bottom">
        <img v-if="bankImage" :src="bankImage" height="26" width="26" class="mr-2" />
        <div>
          <div class="font-weight-bold" style="font-size:13px">{{ BankConciliationItem.Bank.Name }}</div>
          <div class="text-muted" style="font-size:11px">
            Ag: {{ BankConciliationItem.BankAgency }}-{{ BankConciliationItem.BankAgencyDigit }}
            &nbsp;·&nbsp;
            CC: {{ BankConciliationItem.BankAccount }}-{{ BankConciliationItem.BankAccountDigit }}
          </div>
        </div>
      </div>

      <div class="bc-amount" :style="'color:' + cardColor">
        {{ BankConciliationItem.Amount | currency }}
      </div>

      <div class="bc-fields">
        <div class="bc-field">
          <span class="bc-label">Data</span>
          <span>{{ BankConciliationItem.EntryDate | date }}</span>
        </div>
        <div class="bc-field" v-if="BankConciliationItem.BankAccountingCode">
          <span class="bc-label">Cód. Histórico</span>
          <span class="font-weight-bold">{{ BankConciliationItem.BankAccountingCode }}</span>
        </div>
        <div class="bc-field" v-if="BankConciliationItem.EntryCategoryName">
          <span class="bc-label">Cat. Lançamento</span>
          <span class="bc-value-truncate">{{ BankConciliationItem.EntryCategoryName }}</span>
        </div>
        <div class="bc-field">
          <span class="bc-label">Descrição</span>
          <span class="bc-value-truncate text-muted">{{ BankConciliationItem.Description }}</span>
        </div>
      </div>
    </template>

    <!-- Contas a Pagar / Receber -->
    <template v-else>
      <div class="bc-amount" :style="'color:' + cardColor">
        {{ BankConciliationItem.Amount | currency }}
      </div>

      <div class="bc-fields">
        <div class="bc-field">
          <span class="bc-label">Vencimento</span>
          <span>{{ BankConciliationItem.DueDate | date }}</span>
        </div>
        <div class="bc-field" v-if="BankConciliationItem.CategoryName">
          <span class="bc-label">Categoria</span>
          <span class="bc-value-truncate">{{ BankConciliationItem.CategoryName }}</span>
        </div>
        <div class="bc-field" v-if="BankConciliationItem.Description">
          <span class="bc-label">Forma Pgto.</span>
          <span class="bc-value-truncate text-muted">{{ BankConciliationItem.Description }}</span>
        </div>
        <div class="bc-divider" v-if="conciliationOriginLabel || BankConciliationItem.SupplierName"></div>
        <div class="bc-field" v-if="conciliationOriginLabel">
          <span class="bc-label">Origem</span>
          <span class="badge" :class="conciliationOriginClass">{{ conciliationOriginLabel }}</span>
        </div>
        <div v-if="conciliationOriginLabel && BankConciliationItem.SupplierName" class="bc-divider"></div>
        <div class="bc-field" v-if="BankConciliationItem.SupplierName">
          <span class="bc-label">Cedente</span>
          <span class="bc-value-truncate">{{ BankConciliationItem.SupplierName }}</span>
        </div>
        <div class="bc-field" v-if="BankConciliationItem.SupplierIdentity">
          <span class="bc-label">CPF/CNPJ</span>
          <span>{{ BankConciliationItem.SupplierIdentity | identity }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "BankConciliationItemCard",
  props: {
    BankConciliationItem: {
      type: Object,
      required: true
    }
  },
  computed: {
    bankImage() {
      try {
        var path = this.$options.filters.bankImgByCode(this.BankConciliationItem.Bank.Code);
        if (!path) return null;
        var tempValue = path.split("/assets/");
        tempValue.shift();
        tempValue = tempValue.join("/assets/");
        var format = tempValue.split(".").slice(-1);
        tempValue = tempValue.replace("." + format, "");
        if (format == "png") return require("../../../assets/" + tempValue + ".png");
        if (format == "jpg") return require("../../../assets/" + tempValue + ".jpg");
        if (format == "jpeg") return require("../../../assets/" + tempValue + ".jpeg");
      } catch (e) {
        return null;
      }
      return null;
    },
    cardColor() {
      if (this.BankConciliationItem.TypeConciliation == 1) {
        return this.BankConciliationItem.EntryType.Code == 'D' ? '#dc3545' : '#28a745';
      } else if (this.BankConciliationItem.TypeConciliation == 2) {
        return '#dc3545';
      } else if (this.BankConciliationItem.TypeConciliation == 3) {
        return '#28a745';
      }
      return '#6c757d';
    },
    cardTitle() {
      if (this.BankConciliationItem.TypeConciliation == 1) {
        return this.BankConciliationItem.EntryType.Name;
      } else if (this.BankConciliationItem.TypeConciliation == 2) {
        return 'Contas a Pagar';
      } else if (this.BankConciliationItem.TypeConciliation == 3) {
        return 'Contas a Receber';
      }
      return '';
    },
    conciliationOriginLabel() {
      var mode = this.BankConciliationItem.ConciliationInsertMode;
      if (mode === 'A') return 'Automático';
      if (mode === 'C') return 'Manual';
      if (mode === 'M') return 'Pré-existente';
      return null;
    },
    conciliationOriginClass() {
      var mode = this.BankConciliationItem.ConciliationInsertMode;
      if (mode === 'A') return 'badge-info';
      if (mode === 'C') return 'badge-primary';
      if (mode === 'M') return 'badge-secondary';
      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
.bc-card {
  background: #fff;
  border: 1px solid #e1e5eb;
  border-radius: 6px;
  overflow: hidden;
}

.bc-header {
  padding: 8px 12px;
  background: #f8f9fa;
  border-bottom: 1px solid #e1e5eb;
}

.bc-type-label {
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.bc-id {
  font-size: 11px;
  font-family: monospace;
}

.bc-bank-row {
  display: flex;
  align-items: center;
  padding: 10px 12px;
}

.bc-amount {
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  padding: 10px 12px 6px;
}

.bc-fields {
  padding: 4px 12px 10px;
}

.bc-field {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 3px 0;
  font-size: 12px;
  gap: 8px;
}

.bc-label {
  color: #6c757d;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

.bc-value-truncate {
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 160px;
}

.bc-divider {
  border-top: 1px solid #e1e5eb;
  margin: 6px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/BankConciliation/BankConciliationItemCard.vue